var map = {
	"./White-Bishop.svg": "./src/Assets/ChessPieces/White-Bishop.svg",
	"./White-King.svg": "./src/Assets/ChessPieces/White-King.svg",
	"./White-Knight.svg": "./src/Assets/ChessPieces/White-Knight.svg",
	"./White-Pawn.svg": "./src/Assets/ChessPieces/White-Pawn.svg",
	"./White-Queen.svg": "./src/Assets/ChessPieces/White-Queen.svg",
	"./White-Rook.svg": "./src/Assets/ChessPieces/White-Rook.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/Assets/ChessPieces sync recursive ^\\.\\/White\\-.*\\.svg$";